import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const UserForm_UsersPersonIds_Query = graphql(`
  query UserForm_UsersPersonIds_Query {
    findAllUsers {
      _id
      personId
    }
  }
`);

// The people having a user already cannot get another one.
export const useUsersPersonIdsQuery = () =>
  useGraphQLQuery(UserForm_UsersPersonIds_Query);
